import React from "react";

export const ArrowDownIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="10"
      height="8"
      viewBox="0 0 10 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6.14603 7.40268C5.60974 8.1991 4.39026 8.19911 3.85397 7.40268L0.218609 2.004C-0.364268 1.13839 0.286747 1.61125e-07 1.36464 2.49075e-07L8.63536 8.42327e-07C9.71325 9.30277e-07 10.3643 1.13839 9.78139 2.004L6.14603 7.40268Z"
        fill="#0054AC"
      />
    </svg>
  );
};
